import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import {  useSelector } from "react-redux";

const SkopicProtected = (props) => {
  const signInStatus = Cookies.get('signInStatus');
  const isAuthorized = useSelector((state) => state.SignInReducer.isAuthorized);
  if (signInStatus === "true" || isAuthorized === true) {
    return <Route {...props} />;
  }
  return <Redirect to="/" />;
};

export default SkopicProtected;
